import React from "react";
import { useI18n } from "../i18n";

export default function LegalPage({ ns }) {
  const { t } = useI18n();
  const keys = ["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8", "s9", "s10"];

  return (
    <main id="main-content" className="legal-page" data-testid={`page-${ns}`}>
      <div className="container legal-page__inner">
        <header className="legal-page__header">
          <h1>{t(`${ns}.title`)}</h1>
          <p className="legal-page__meta">{t(`${ns}.updated`)}</p>
          <p className="legal-page__intro">{t(`${ns}.intro`)}</p>
        </header>
        <div className="legal-page__body">
          {keys
            .map((k) => ({ k, title: t(`${ns}.${k}.title`, null), text: t(`${ns}.${k}.text`, null) }))
            .filter((s) => s.title && s.text)
            .map((s) => (
              <section key={s.k}>
                <h2>{s.title}</h2>
                <p>{s.text}</p>
              </section>
            ))}
        </div>
      </div>
    </main>
  );
}
